export default "__VITE_ASSET__CaDJzRL5__"